module.exports = __webpack_public_path__ + "static/media/Arrow Left.42e62815.svg";